// src/pages/organismos/TribunalSuperior.jsx

const tribunalMiembros = [
  { 
    cargo: "Presidente", 
    nombre: "Pascual Senén Luza Centeno", 
    tratamiento: "R.·. H.·." 
  },
  { 
    cargo: "Secretario", 
    nombre: "Ricardo Enrique Yturbe López", 
    tratamiento: "R.·. H.·." 
  },
  { 
    cargo: "Vocal", 
    nombre: "Juan Francisco Salgado Laynes", 
    tratamiento: "R.·. H.·." 
  },
  { 
    cargo: "Vocal", 
    nombre: "Pedro Pablo Díaz Lavado", 
    tratamiento: "R.·. H.·." 
  },
  { 
    cargo: "Vocal", 
    nombre: "Luis Roberto Dulanto Gayoso", 
    tratamiento: "R.·. H.·." 
  }
];

const TribunalSuperior = () => {
  return (
    <div className="min-h-screen bg-[#050505] text-white selection:bg-[#C5A059] selection:text-[#050505] font-sans pt-24 flex flex-col">
      
      {/* Hero Section */}
      <section className="relative w-full pt-32 pb-16 md:pt-40 md:pb-24 flex flex-col items-center justify-center overflow-hidden border-b border-white/5">
        <div 
          className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-20"
          style={{ backgroundImage: "url('https://images.unsplash.com/photo-1589829085413-56de8ae18c73?q=80&w=2000&auto=format&fit=crop')" }} // Imagen de mazo/justicia/arquitectura
        ></div>
        <div className="absolute inset-0 bg-gradient-to-b from-[#050505]/90 via-[#050505]/60 to-[#050505]"></div>

        <div className="relative z-10 text-center px-4 w-full max-w-4xl mx-auto">
          <p className="text-[#C5A059] tracking-[0.4em] uppercase text-xs md:text-sm font-light mb-4 animate-fade-in">
            Organismos Jurisdiccionales
          </p>
          <h1 className="font-serif text-4xl md:text-6xl font-normal text-white tracking-tight animate-fade-in [animation-delay:0.3s] drop-shadow-lg mb-6">
            Tribunal Superior de Justicia
          </h1>
          <div className="flex flex-col items-center gap-2 animate-fade-in [animation-delay:0.6s]">
            <p className="text-gray-400 font-light text-sm md:text-base tracking-widest">
              Periodo 2025 - 2026 E.·.V.·.
            </p>
            <p className="text-[#C5A059] text-xs tracking-widest uppercase border border-[#C5A059]/30 px-4 py-1 mt-2">
              Decreto 143-372 GLP
            </p>
            <p className="text-gray-500 text-xs mt-2">
              07 de mayo 2025
            </p>
          </div>
        </div>
      </section>

      {/* Contenido Principal: Directorio del Tribunal */}
      <section className="relative z-20 max-w-6xl mx-auto px-6 lg:px-12 py-16 md:py-24 flex-grow w-full">
        
        {/* Grilla de Miembros */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          
          {/* Tarjeta del Presidente (Destacada, ocupa 100% en móvil, 2 columnas en lg para centrar si son impares) */}
          <div className="md:col-span-2 lg:col-span-3 flex justify-center mb-8">
            <div className="w-full max-w-md bg-gradient-to-br from-[#0a0a0a] to-[#111111] border-t-2 border-[#C5A059] p-8 md:p-10 shadow-2xl text-center group hover:-translate-y-1 transition-transform duration-500">
              <span className="text-[#C5A059] text-xs tracking-[0.3em] uppercase block mb-6 font-semibold">
                {tribunalMiembros[0].cargo}
              </span>
              <p className="text-gray-500 text-xs tracking-widest uppercase mb-2">
                {tribunalMiembros[0].tratamiento}
              </p>
              <h3 className="font-serif text-2xl md:text-3xl text-white group-hover:text-[#C5A059] transition-colors">
                {tribunalMiembros[0].nombre}
              </h3>
            </div>
          </div>

          {/* Resto de Miembros (Secretario y Vocales) */}
          {tribunalMiembros.slice(1).map((miembro, index) => (
            <div 
              key={index} 
              className="bg-[#0a0a0a] border border-white/5 p-8 text-center group hover:border-[#C5A059]/40 transition-colors duration-500"
            >
              <span className="text-gray-400 text-xs tracking-[0.2em] uppercase block mb-6 border-b border-white/10 pb-4 inline-block">
                {miembro.cargo}
              </span>
              <p className="text-gray-500 text-xs tracking-widest uppercase mb-2">
                {miembro.tratamiento}
              </p>
              <h3 className="font-serif text-xl md:text-2xl text-white group-hover:text-[#C5A059] transition-colors">
                {miembro.nombre}
              </h3>
            </div>
          ))}

        </div>

      </section>

      {/* Footer de Contacto Específico */}
      <section className="bg-[#0a0a0a] border-t border-white/5 py-12">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <p className="text-gray-500 text-xs tracking-[0.2em] uppercase mb-4">
            Contacto Oficial
          </p>
          <a 
            href="mailto:tribunalsuperiordejusticiaglp@gmail.com" 
            className="inline-flex items-center gap-3 text-[#C5A059] hover:text-white transition-colors text-sm md:text-base tracking-wider"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
            </svg>
            tribunalsuperiordejusticiaglp@gmail.com
          </a>
        </div>
      </section>

    </div>
  );
};

export default TribunalSuperior;